const Select = () => {
  return {
    MuiSelect: {
      variants: [
        {
          props: { variant: 'custom-select' },
        },
      ],
    },
  };
};
export default Select;
